"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VirtualPort = void 0;

var port_1 = require("./port");

var virtual_port_1 = require("./http/virtual_port");

var VirtualPort =
/** @class */
function (_super) {
  __extends(VirtualPort, _super);

  function VirtualPort(id, index, label, type, value, unit, time, valueType, maxPeriod, minPeriod, readingMethod, measuredFigures, actuatable, expressions, input) {
    if (input === void 0) {
      input = "";
    }

    var _this = _super.call(this, id, index, label, type, value, unit, time, valueType, maxPeriod, minPeriod, readingMethod, measuredFigures, actuatable) || this;

    _this.expressions = expressions;
    _this.input = input;
    return _this;
  }

  VirtualPort.prototype.create = function (uuid, cred) {
    return virtual_port_1.createVirtualPort(this.encode(), uuid, cred);
  };

  VirtualPort.prototype.encode = function () {
    return {
      "index": this.index,
      "unit": this.unit,
      "label": this.label,
      "expressions": this.expressions,
      "input": this.input
    };
  };

  return VirtualPort;
}(port_1.Port);

exports.VirtualPort = VirtualPort;